export const isEmptyHtml = (test: string) => {
  const testDiv = document.createElement('div')
  testDiv.innerHTML = test

  if (!testDiv.childNodes || testDiv.childNodes.length === 0) {
    return true
  }

  const htmlTest = (node: HTMLElement | ChildNode): boolean => {
    for (const testNode of Array.from(node.childNodes)) {
      // Check for a textNode type
      if (testNode.nodeType === 3) {
        return false
      }

      // Check innerText (this is important for elements like <pre>)
      const testElement = testNode as HTMLElement
      if (testElement.innerText) {
        return false
      }

      switch (testElement.nodeName) {
        case 'IMG':
        case 'AUDIO':
        case 'VIDEO':
          return false
      }

      // Recursively check children
      if (testNode.childNodes.length > 0) {
        return htmlTest(testNode)
      }
    }

    return true
  }

  return htmlTest(testDiv)
}
